import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconCursorClick = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.989,20.818 C23.989,21.084 23.883,21.339 23.695,21.526 L21.504,23.708 C21.309,23.902 21.052,24.000 20.795,24.000 C20.539,24.000 20.282,23.902 20.086,23.707 L14.949,18.585 L12.739,20.719 C12.497,20.951 12.153,21.048 11.828,20.977 C11.500,20.906 11.229,20.676 11.107,20.364 L6.001,7.364 C5.855,6.995 5.944,6.574 6.226,6.293 C6.507,6.012 6.929,5.924 7.301,6.069 L11.947,7.883 C11.999,7.593 12.033,7.299 12.033,7.000 C12.033,4.243 9.783,2.000 7.017,2.000 C4.252,2.000 2.002,4.243 2.002,7.000 C2.002,9.271 3.537,11.259 5.736,11.835 C6.272,11.975 6.592,12.523 6.452,13.056 C6.333,13.505 5.926,13.802 5.482,13.802 C5.398,13.802 5.312,13.792 5.226,13.769 C2.146,12.962 -0.005,10.178 -0.005,7.000 C-0.005,3.140 3.145,0.000 7.017,0.000 C10.889,0.000 14.039,3.140 14.039,7.000 C14.039,7.550 13.956,8.090 13.831,8.618 L20.342,11.160 C20.655,11.282 20.885,11.552 20.956,11.879 C21.028,12.206 20.930,12.547 20.697,12.787 L18.557,14.989 L23.695,20.111 C23.883,20.299 23.989,20.553 23.989,20.818 ZM16.440,15.707 C16.052,15.321 16.047,14.696 16.428,14.304 L18.207,12.474 L8.706,8.765 L12.426,18.236 L14.262,16.463 C14.457,16.276 14.709,16.182 14.960,16.182 C15.217,16.182 15.474,16.280 15.670,16.474 L20.796,21.586 L21.567,20.818 L16.440,15.707 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconCursorClick.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
